module.exports = new __parcel__URL__("gamebook-services_logo_transp.209fd0b0.png").toString();